
import {finalize} from 'rxjs/operators';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Dialog } from '../../ui/dialog/dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { SLEntity, SLEntityType } from './entity';
import { SLEntityService, SLEntityFilter } from './entity.service';
import { NotifierService } from '../../ui/alert/notifier.service';

import { filter as lodashFilter, size } from 'lodash';

const FILTER_KEY = 'entities.search-filter';

/**
 * Entity filter dialog
 */
@Component({
  templateUrl: './entity-search-dialog.component.html',
  host: {'(window:keydown)': 'hotkeys($event)'},
  styles: [
    `.dialog-container {
      display: block;
      position: fixed;
      z-index: 300;
      width: 100%;
      left: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            top: '0px'
          })
        ),
        state(
          'closed',
          style({
            top: '-136px'
          })
        ),
        transition('closed => open', animate('400ms ease-out')),
        transition('open => closed', animate('400ms ease-in')),
      ]
    ),
  ]
})
export class SLEntitySearchDialogComponent implements Dialog, OnInit {
  state = 'closed';

  search: string
  hideId: string
  type?: SLEntityType

  lastSearch: string
  searchTimer: any

  @ViewChild('searchInput')
  searchInput: ElementRef

  entities: SLEntity[]
  selectedItem: SLEntity
  
  onClose: () => void
  onSelect: (entity: SLEntity) => void

  constructor(
    private entityService: SLEntityService,
    private notifier: NotifierService,
  ) {

  }

  ngOnInit() {
    if(!this.search) {

      // Load filter from localStorage
      if(window.localStorage) {
        try {
          this.search = window.localStorage.getItem(FILTER_KEY);
        }
        catch(err) {}
      }
      
      if(!this.search) {
        this.search = '';
      }
    }

    this.lastSearch = this.search;

    this.apply();

    // Focus search input
    this.searchInput.nativeElement.focus();
  }

  close() {
    this.onClose();
  }

  select(entity: SLEntity) {
    this.onSelect(entity);
  }

  apply() {
    let filter = new SLEntityFilter();
    filter.search = this.search;
    filter.offset = 0;
    filter.limit = 10;
    filter.orderBy = 'NAME';
    filter.orderDir = 'ASC';

    if (this.type) {
      filter.type = this.type;
    }

    this.notifier.startProgress();

    this.entityService
      .entities(filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        if(this.hideId) {
          this.entities = lodashFilter(result.entities, entity => {
            return entity.id !== this.hideId;
          });
        }
        else {
          this.entities = result.entities;
        }

        if(size(this.entities) > 0) {
          this.selectedItem = this.entities[0];
        }
      });

    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, this.search);
    }
  }

  hotkeys(event: KeyboardEvent){
    
    switch(event.keyCode) {
      // Escape key
      case 27:
        this.close();
        break;
      // Enter key
      case 13:
        if(size(this.entities) && this.selectedItem) {
          this.select(this.selectedItem);
        }
        event.preventDefault();
        return false;
      // Up Arrow key
      case 38:
        if(size(this.entities) > 0) {
          let selectedIndex = this.entities.indexOf(this.selectedItem);

          if(selectedIndex >= 0) {
            selectedIndex -= 1;

            if(selectedIndex >= 0) {
              this.selectedItem = this.entities[selectedIndex];
            }
          }
        }
        break;
      // Down Arrow key
      case 40:
        if(size(this.entities) > 0) {
          let selectedIndex = this.entities.indexOf(this.selectedItem);

          if(selectedIndex >= 0) {
            selectedIndex += 1;

            if(selectedIndex < this.entities.length) {
              this.selectedItem = this.entities[selectedIndex];
            }
          }
        }
        break;
    }
  }

  searchKeyup(event: KeyboardEvent) {
    if(this.lastSearch !== this.search) {
      this.lastSearch = this.search;

      if(this.searchTimer) {
        window.clearTimeout(this.searchTimer);
      }

      this.searchTimer = window.setTimeout(() => {
        this.apply();
      }, 500);
    }
  }
}

